import { render, staticRenderFns } from "./Func52.vue?vue&type=template&id=e8654b46"
import script from "./Func52.vue?vue&type=script&lang=js"
export * from "./Func52.vue?vue&type=script&lang=js"
import style0 from "./Func52.vue?vue&type=style&index=0&id=e8654b46&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports